import Container from './TopicActions.container';
import TopicActions from './TopicActions';

export default Container(TopicActions);
